var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pot-scroll',{ref:"scroll",staticClass:"tk-scroll",attrs:{"options":{
			pullDownRefresh:_vm.canPullDownCpt,
			pullUpLoad:_vm.data.length&&_vm.canPullUpCpt
		}},on:{"pulling-up":_vm.pullUp,"pulling-down":_vm.pullDown}},[_vm._t("default"),_vm._v(" "),(!_vm.data.length)?_c('div',{staticClass:"nodata-icon"}):_vm._e(),_vm._v(" "),(_vm.data.length&&_vm.options.pullUp&&!_vm.canpullUp)?_c('div',{staticClass:"no-more"},[_vm._v("\r\n\t\t\t暂无更多数据\r\n\t\t")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }